'use strict';
var toString = require('../internals/to-string');

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/normalize-string-argument.js
// module id = 677
// module chunks = 13